import type { BasicResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getChangePassword = async (lang?: string) => {
    return await getGenericEndpoint<BasicResponse>('change-password', lang);
};
